module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"support":"Assistenza","helpText":"Per richieste di assistenza contattare il nostro ufficio ai seguenti recapiti:","emergency":"Per urgenze"},"en":{"support":"Support","helpText":"For assistance requests, please contact our office at the following contact details:","emergency":"Emergency"}}')
  delete Component.options._Ctor
}
